const SIGNATURE_REQUIRED_MESSAGE = 'Signature is required to submit the consent form.';

export const SIGNATURE_UPLOAD_ACCEPT = '.jpg,.jpeg,.png';
export const SIGNATURE_UPLOAD_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
export const SIGNATURE_UPLOAD_MAX_BYTES = 10 * 1024 * 1024;

export function isValidConsentSignature(signature) {
  if (!signature || typeof signature !== 'string') return false;
  const trimmed = signature.trim();
  if (
    trimmed.startsWith('/api/uploads/') ||
    trimmed.startsWith('/uploads/') ||
    trimmed.startsWith('uploads/') ||
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://')
  ) {
    return true;
  }
  if (!trimmed.startsWith('data:image/')) return false;
  const commaIdx = trimmed.indexOf(',');
  if (commaIdx === -1) return false;
  const base64 = trimmed.slice(commaIdx + 1).trim();
  return base64.length >= 50;
}

export function getConsentSignatureValidationError(signature) {
  return isValidConsentSignature(signature) ? null : SIGNATURE_REQUIRED_MESSAGE;
}

export function getSignatureUploadValidationError(file) {
  if (!file) return null;
  const mime = String(file.type || '').toLowerCase();
  const name = String(file.name || '').toLowerCase();
  const hasValidMime = SIGNATURE_UPLOAD_MIME_TYPES.includes(mime);
  const hasValidExt = /\.(jpe?g|png)$/.test(name);
  if (!hasValidMime && !hasValidExt) {
    return 'Please upload a JPG or PNG signature image.';
  }
  if (file.size > SIGNATURE_UPLOAD_MAX_BYTES) {
    return 'Signature image must be 10 MB or smaller.';
  }
  return null;
}

export function readSignatureFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const validationError = getSignatureUploadValidationError(file);
    if (validationError) {
      reject(new Error(validationError));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Failed to read the signature image.'));
    reader.readAsDataURL(file);
  });
}

export { SIGNATURE_REQUIRED_MESSAGE };
